import {
  GetChangeEmailHelpLinkFunction,
  GetChangeEmailNativeVerificationLinkFunction,
  GetChangePasswordHelpLinkFunction,
  GetChangePasswordNativeVerificationLinkFunction,
  GetChangePhoneContactUsLinkFunction,
  GetUserAccountChangePhoneContactUsLinkFunction,
} from '@shopee-user/business-customization-types';

export const getChangeEmailHelpLink: GetChangeEmailHelpLinkFunction = () => '';

export const getChangeEmailNativeVerificationLink: GetChangeEmailNativeVerificationLinkFunction = () =>
  '';

export const getChangePasswordHelpLink: GetChangePasswordHelpLinkFunction = () =>
  '';

export const getChangePasswordNativeVerificationLink: GetChangePasswordNativeVerificationLinkFunction = () =>
  '';

export const getChangePhoneContactUsLink: GetChangePhoneContactUsLinkFunction = () =>
  '';

export const getUserAccountChangePhoneContactUsLink: GetUserAccountChangePhoneContactUsLinkFunction = () =>
  '';
